module.exports = "/images/Sub-Hero.jpg";